import { createSlice } from "@reduxjs/toolkit";
import {
  getReferralActivity,
  getSterlingWallet,
  getWalletActivity,
  getWalletBalance,
  transferSterlingFunds,
} from "../actions/walletActions";

const initialWalletState = {
  balance: 0,
  currentUnit: 0,
  freeUnit: 0,
  activity: {},
  bonusData: {},
  loading: true,
  activeView: "Credit",
  totalEarned: 0,
  totalInvitee: 0,
  referralUrl: "",
  doneLoading: false,
  sterling: {
    accountNumber: "",
    accountName: "",
    accountImg: "",
    bankName: "Sterling Bank",
    balance: 0,
    loading: false,
    doneLoading: false,
  },
};
const walletSlice = createSlice({
  name: "wallet",
  initialState: initialWalletState,
  reducers: {
    setBalance(state, action) {
      state.balance = action.payload;
    },

    setActivity(state, actions) {
      state.activity = actions.payload;
    },

    setActiveView(state, actions) {
      state.activeView = actions.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getWalletBalance.fulfilled, (state, action) => {
        state.balance = action.payload.balance;
      })
        .addCase(getWalletBalance.rejected, (state, action) => {
          state.balance = 0;
        })
      .addCase(getWalletActivity.fulfilled, (state, action) => {
        state.activity = action.payload.activity;
      })
      .addCase(getWalletActivity.rejected, (state, action) => {
          state.activity = {};
        })
        .addCase(getReferralActivity.fulfilled, (state, action) => {
          state.bonusData = action.payload.bonusData;
          if(action.payload.referralUrl) {
            state.totalEarned = action.payload.totalEarned;
            state.totalInvitee = action.payload.totalInvitee;
            state.referralUrl = action.payload.referralUrl;
            state.currentUnit = action.payload.currentUnit;
            state.freeUnit = action.payload.freeUnit;
          }
          state.loading = false;
          state.doneLoading = true;
        })
        .addCase(getReferralActivity.rejected, (state, action) => {
          state.bonusData = {};
          state.loading = false;
        })
        .addCase(getSterlingWallet.pending, (state) => {
          state.sterling.loading = true;
        })
        .addCase(getSterlingWallet.fulfilled, (state, action) => {
          const p = action.payload;
          if (p) {
            state.sterling.accountNumber = p.accountNumber;
            state.sterling.accountName = p.accountName;
            state.sterling.accountImg = p.accountImg || "";
            state.sterling.bankName = p.bankName || "Sterling Bank";
            state.sterling.balance = p.balance;
          }
          state.sterling.loading = false;
          state.sterling.doneLoading = true;
        })
        .addCase(getSterlingWallet.rejected, (state, action) => {
          state.sterling.loading = false;
          state.sterling.doneLoading = true;
        })
        .addCase(transferSterlingFunds.fulfilled, (state, action) => {
          if (action.payload?.balance !== undefined) {
            state.sterling.balance = action.payload.balance;
          }
        });
  },
});

export const { setBalance, setActivity, setActiveView } = walletSlice.actions;

export default walletSlice.reducer;
